import { toRef } from 'vue'
import { useAccountStatusQuery } from './useAccountStatusQuery'

function createInstance() {
  const { data } = useAccountStatusQuery()
  const issues = toRef(() => data.value?.issues)
  return { issues }
}

export const useAccountStatusIssues = useSingleton(createInstance)
